import { CircleAlert, TriangleAlert, CheckCircle, Info } from "lucide-react";
import type { ToastType } from "./toast.types.js";

export const TOAST_ICONS: Record<ToastType, typeof CheckCircle> = {
  success: CheckCircle,
  error: CircleAlert,
  warning: TriangleAlert,
  info: Info,
} as const;

export const TOAST_VARIANTS: Record<ToastType, "destructive" | "default"> = {
  success: "default",
  error: "destructive",
  warning: "default",
  info: "default",
} as const;
